import { Component } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';

@Component({
  selector: 'view-button',
  styleUrls: ['./viewButton.component.scss'],
  templateUrl: './viewButton.component.html',
})
export class ViewButtonComponent implements AgRendererComponent {
  refresh(params: any): boolean {
    return undefined;
  }
  private params: any;

  public status = 'open';

  agInit(params: any): void {
    this.params = params;
    this.status = params.data.academyStatus.appStatus;
  }

  public invokeEdit() {
    this.params.context.componentParent.onActionDownloadClick(this.params.data);
  }
}
